<template>
  <!-- payment -->
    <div class="d-flex flex-column align-items-center fade-in">
      <content-header title="Summary & Payment" :sub-title="subTitle" class="w-100 mxw-lg"/>
      <div class="d-flex justify-content-center w-100 mb--10" v-if="isLoaded">
        <el-row class="payment-container" :gutter="20">
          <el-col class="mt-10" v-bind="resCol">
            <content-header title="Registration Summary" class="fs-09 mt--10"/>
            <div class="mb--05">
              <div class="mt-10" v-for="(rego, idx) in summary" :key="idx">
                <!-- <div class="fs-15">{{ rego.teamName }}</div> -->
                <!-- <div class="event">{{ event.name }}</div> -->
                <div><span class="title">Entity Type:</span>{{ getEntityType }}</div>
                <div><span class="title">Entity Name:</span>{{ rego.entityName }}</div>
                <div><span class="title">Parent Entity:</span>{{ membership.orgtree[membership.entityType].name }}</div>
                <div><span class="title">Membership:</span>{{ membership.name }}</div>
                <div v-if="rego.tags && rego.tags.length > 0"><span class="title">Tags:</span>{{ rego.tags | joinTag }}</div>
                <div class="d-flex mt-05">
                  <!-- <div><span class="title">Registration Type:</span>{{ rego.productType | parseProductType }}</div> -->
                  <!-- <div class="ml-10"><span class="title">Member Type:</span>{{ rego.memberType | cap }}</div> -->
                </div>
                <el-table :data="rego.products" class="item-table mt-05">
                  <el-table-column label="Product" width="auto" min-width="200">
                    <template slot-scope="scope">
                      <div class="product-info d-flex flex-column">
                        <div class="name">{{ scope.row.name }}</div>
                        <div class="description">{{ scope.row.description }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="qty" label="QTY" width="100"></el-table-column>
                  <el-table-column label="Cost" width="150">
                    <template slot-scope="scope">
                      {{ scope.row.total | parsePrice}}
                    </template>
                  </el-table-column>
                </el-table>
                <!-- TODO discount   -->
                <!-- <div class="d-flex justify-content-end mt-05">
                  <span class="f-light text-underline pointer">+ Add Discount</span>
                  <span class="f-light ml-10 text-underline pointer">+ Add Active Kids Voucher</span>
                </div>
                <div class="d-flex justify-content-center mt-10">
                  <el-button type="primary" class="bottomBtn" @click="edit" disabled>Edit</el-button>
                  <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx)">Remove</el-button>
                </div> -->
                <div v-if="payTodayTotal > 0" class="redeem">
                  <div class="mt-10 d-flex justify-content-between">
                    <el-input v-model="payment.discountCode" :disabled="redeemed" v-mask="'######'" class="discount-code" placeholder="Enter your discount code" ></el-input>
                    <el-button type="primary" :disabled="redeemed" class="ml-10" @click="redeem">Redeem Code</el-button>
                  </div>
                </div>
                <div class="d-flex justify-content-between fs-07">
                  <h2>Discount Total:</h2>
                  <h2>{{ discountTotal | parsePrice }}</h2>
                </div>
                <div class="d-flex justify-content-between fs-09">
                  <h2>Cart Total:</h2>
                  <h2>{{ payTodayTotal | parsePrice }}</h2>
                </div>
              </div>
            </div>
            </el-col>
            <el-col class="mt-10" :xs="24" :sm="24" :md="12" :lg="12"  v-if="requirePayment">
              <content-header :title="paymentTitle" class="fs-09 mt--10"/>
              <el-form ref="form" :model="payment" :rules="rules">
                <div>
                  <div class="pay-after mb-15" v-if="payAfter">
                    <h3 class="f-light mt--05">Pay After Details</h3>
                    <small> Minimum Payment: <b>{{ minPayment | parsePrice }}</b> </small>
                    <el-row class="d-flex align-items-center mt-15">
                      <el-col :span="20" :md="12">
                        <el-price-input v-model="payToday" :min="minPayment" :max="cartTotal" />
                      </el-col>
                      <h1 class="price-divider"> / </h1>
                      <h3>{{ cartTotal | parsePrice }}</h3>
                    </el-row>
                  </div>
                  <h3 class="f-light mt--05">Credit Card Details</h3>
                  <small v-if="nationalId !==1"> *International Credit Cards are not accepted </small>
                  <credit-card v-model="payment.card" :width="230" :cardClass="'custom-card'" ref="card" data-dd-privacy="hidden"/>
                  <el-divider />
                  <h3 class="f-light">Billing Address</h3>
                  <div class="mt--10" v-if="fillingAddress">
                    <span type="text" class="text-underline c-lightblack fs-09 pointer" @click="fillAddress(fillingAddress)">Fill address with {{ fillingAddress.formatted }}</span>
                  </div>
                  <el-row :gutter="20">
                    <el-col :span="24" :md="12" class="mt-10">
                      <el-input-title required>Address Line 1</el-input-title>
                      <el-form-item prop="billingAddress.addressLine1">
                        <el-input class="mt-05" v-model="payment.billingAddress.addressLine1" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10">
                      <el-input-title>Address Line 2</el-input-title>
                      <el-form-item prop="billingAddress.addressLine2">
                        <el-input class="mt-05" v-model="payment.billingAddress.addressLine2" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10">
                      <el-input-title required>City/Suburb</el-input-title>
                      <el-form-item prop="billingAddress.suburb">
                        <el-input class="mt-05" v-model="payment.billingAddress.suburb" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10">
                      <el-input-title :required="nationalId !== 17">State</el-input-title>
                      <el-form-item prop="billingAddress.state">
                        <el-input class="mt-05" v-model="payment.billingAddress.state" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10">
                      <el-input-title required>Postcode</el-input-title>
                      <el-form-item prop="billingAddress.postcode">
                        <el-input class="mt-05" v-model="payment.billingAddress.postcode" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10">
                      <el-input-title required>Country</el-input-title>
                      <el-form-item prop="billingAddress.country">
                        <el-autocomplete
                          class="mt-05 w-100"
                          v-model="payment.billingAddress.country"
                          :fetch-suggestions="searchCountry"
                          placeholder="Select"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- <el-row>
                  <el-col :span="24" class="d-flex justify-content-center">
                    <el-button type="primary" class="btn-highlight payBtn" @click.prevent="pay" :disabled="isPayDisabled">Pay & Complete</el-button>
                  </el-col>
                </el-row> -->
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>
    </template>

<script>
import _ from 'lodash';
import { VueMaskDirective } from 'v-mask';

import { errormsg, countries, productTypes } from '@/utils/constants';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };

export default {
  name: 'Payment',
  props: {
    value: Object,
    membership: Object
  },
  directives: {
    mask: VueMaskDirective
  },
  data() {
    const pin = new Pin.Api(process.env.VUE_APP_PIN_PK, process.env.VUE_APP_PIN_ENV);
    return {
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      pin,
      isLoaded: false,
      subTitle: 'Please verify all the information displayed below is correct before proceeding. A receipt will be sent to the member\'s email address upon completion',
      registration: this.value,
      redeemError: '',
      redeemed: false,
      payment: {
        registrations: [this.value],
        card: {},
        billingAddress: {},
        discountCode: undefined
      },
      payToday: 0,
      summary: [],
      countries,
      rules: {
        'billingAddress.addressLine1': defaultRequiredRule,
        'billingAddress.suburb': defaultRequiredRule,
        'billingAddress.state': +process.env.VUE_APP_NATIONAL_ID === 17 ? {} : defaultRequiredRule,
        'billingAddress.postcode': defaultRequiredRule,
        'billingAddress.country': defaultRequiredRule,
      },
      cardWidth: 200,
      resCol: {
        xs: 24, sm: 24, md: 12, lg: 12
      }
    };
  },
  mounted() {
    console.log('payment', this.payment);
    this.isLoaded = false;

    // Convert to summary
    _.forEach(this.payment.registrations, (r) => {
      console.log(r);
      const products = [
        {
          name: 'Registration Fee', qty: 1, total: this.getTotalWithTransactionFee(r.product.price), price: r.product.price
        }
      ];
        // Add custom fees if rego has one
      if (r.product.customFees && r.product.customFees.value > 0) {
        products.push({
          name: r.product.customFees.label === '' ? 'Custom Fee' : r.product.customFees.label,
          qty: 1,
          total: this.getTotalWithTransactionFee(r.product.customFees.value),
        });
      }

      _.forEach(r.saleableItems, (i) => {
        if (i.qty > 0) {
          products.push({
            name: i.name,
            description: i.description,
            qty: i.qty,
            total: this.getTotalWithTransactionFee(i.price * i.qty),
          });
        }
      });

      // format discounts
      const productTotal = _.sumBy(products, 'total');
      _.forEach(r.discounts, (i) => {
        let redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * productTotal) / 100);
        if (redeemedAmount > productTotal) redeemedAmount = productTotal;

        products.push({
          name: i.name,
          description: i.description,
          qty: i.qty,
          total: -redeemedAmount,
          discountType: i.type,
          isDiscount: true
        });
      });

      if (r.discountVoucher && r.discountVoucher.redeemedAmount) {
        products.push({
          name: r.discountVoucher.name,
          description: r.discountVoucher.description,
          qty: 1,
          total: -r.discountVoucher.redeemedAmount,
        });
      }

      this.summary.push({
        entityName: r.entity.name,
        productType: r.productType,
        tags: r.tags,
        products
      });
    });

    if (!this.requirePayment) {
      this.resCol = {
        xs: 24, sm: 24, md: 24, lg: 24
      };
    }

    this.isLoaded = true;
  },
  methods: {
    getTotalWithTransactionFee(total) {
      // If a national has product transaction fee setting, apply it to product
      const preference = this.$store.getters['national/paymentPreference'];
      const { addToProduct } = preference;
      if (!addToProduct) return total;
      return +(total * ((100 + addToProduct) / 100)).toFixed();
    },
    redeem() {
      this.redeemError = '';
      this.$http.post('assemble/api/v1/portal/discount-codes/redeem', {
        code: this.payment.discountCode,
        entityType: 'membership',
        entityId: this.membership._id
      }).then((res) => {
        const {
          type, name, amount, description
        } = res.data.data;

        const productTotal = _.sumBy(this.summary[0].products, 'total');
        let redeemedAmount = type === 'dollar' ? amount : ((amount * productTotal) / 100);
        if (redeemedAmount > productTotal) redeemedAmount = productTotal;

        this.summary[0].products.push({
          name,
          description,
          qty: 1,
          total: -redeemedAmount,
          discountType: type,
          isDiscount: true
        });

        this.redeemed = true;
      }).catch(() => {
        this.redeemError = 'Discount code is invalid';
      });
    },
    searchCountry(query, cb) {
      if (query && query !== '') {
        setTimeout(() => {
          cb(this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1));
        }, 200);
      } else {
        cb([]);
      }
    },
    // edit() {},
    // remove(index) {
    //   this.$confirm('Are you sure you want to remove this registration?', 'Confirm', {
    //     distinguishCancelAndClose: true,
    //     confirmButtonText: 'Yes',
    //     cancelButtonText: 'No',
    //   }).then(() => {
    //     this.$store.commit('cart/remove', index);
    //     this.payment.registrations.splice(index, 1);
    //     this.summary.splice(index, 1);
    //   });
    // },
    fillAddress(address) {
      this.payment.billingAddress = {
        formatted: address.formatted,
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        suburb: address.suburb,
        state: address.state,
        postcode: address.postcode,
        country: address.country,
      };
    },
    register(token) {
      if (this.requirePayment && !token) return false;
      this.$store.commit('loading', true, 'Processing payment...');
      // this.$store.commit('loadingText', 'Processing payment...');
      return this.$http.post('assemble/api/v1/portal/registrations/register/entity', {
        noNewEntity: this.registration.existingEntity,
        registration: this.registration,
        cardToken: token,
        paymentTotal: this.payAfter ? this.payTodayTotal : this.total,
        paymentInstallment: this.payAfter ? this.payToday : this.cartTotal,
        discountCode: this.payment.discountCode
      }).then(() => {
        const confirmationData = {
          ...this.registration,
          entityName: this.membership.name,
        };
        this.$store.commit('cart/successful', [confirmationData]);
        this.$store.commit('cart/clear');
        const pathName = this.hasCustomEntity ? 'custom-success' : 'success';
        this.$router.push({ name: pathName, params: { confirmationData } });
        this.$store.commit('loading', false);
        this.$store.commit('loading', false);
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error(serverError || 'There has been an error');
      });
    },
    updateStep(step) {
      if (step === 1) {
        Promise.all([this.$refs.card && this.$refs.card.validate(), this.$refs.form && this.$refs.form.validate()])
          .then(([cardValid, formValid]) => {
            if (this.requirePayment && (!cardValid || !formValid)) return;

            // if payment is not required || payment total is 0
            if (!this.requirePayment) {
              // call register without card token
              this.register();
              return;
            }

            // issue card token
            const [expiryMonth, expiryYear] = this.payment.card.expiry.replace(/\s/g, '').split('/');

            this.$store.commit('loading', { loading: true, text: 'Loading...' });
            this.pin.createCardToken({
              number: this.payment.card.number,
              name: this.payment.card.name,
              expiry_month: expiryMonth,
              expiry_year: expiryYear,
              cvc: this.payment.card.cvc,
              address_line1: this.payment.billingAddress.addressLine1,
              address_line2: this.payment.billingAddress.addressLine2 || '',
              address_city: this.payment.billingAddress.suburb,
              address_state: this.payment.billingAddress.state,
              address_postcode: this.payment.billingAddress.postcode,
              address_country: 'Australia',
            }).then((pinResponse) => {
              // Block International Cards
              // eslint-disable-next-line camelcase, no-unused-vars
              const { token, issuing_country, scheme } = pinResponse;
              // || !_.includes(['master', 'visa'], scheme)
              // eslint-disable-next-line camelcase

              if (!['AU', 'NZ'].includes(issuing_country) && [14, 18].includes(+process.env.VUE_APP_NATIONAL_ID)) {
                this.$store.commit('loading', false);
                this.$message.error('International cards are not supported.');
                return false;
              }

              if (!token) {
                this.$store.commit('loading', false);
                this.$message.error('There has been an error, try again later.');
              }
              // register with card token
              this.register(token);
            }).catch((err) => {
              this.$store.commit('loading', false);
              const pinError = _.get(err, 'error_description');
              this.$message.error(pinError || 'There has been an error');
            });
          }).catch(() => {});
      } else this.$emit('update-step', this.registration, step);
    }
  },
  computed: {
    getEntityType() {
      const entityType = this.value.product.entityTypeList.find((item) => item.value === this.value.entityRegoType);
      console.log('entityType', entityType);
      return entityType?.name;
    },
    getParentEntityType() {
      const entityType = this.value.product.entityTypeList.find((item) => item.value === this.value.parentEntityRegoType);
      console.log('entityType', entityType);
      return entityType?.name;
    },
    feePercentage() {
      let defaultFee = this.$store.getters['cart/transactionFee'];
      if (!defaultFee) {
        const nationalMeta = this.$store.getters['national/getMeta'];
        if (nationalMeta && nationalMeta.transactionFee) {
          defaultFee = +nationalMeta.transactionFee;
        }
      }
      const preference = this.$store.getters['national/paymentPreference'];
      const { addToTotal } = preference;
      return addToTotal >= 0 ? addToTotal : defaultFee;
    },
    national() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
    discountTotal() {
      let total = 0;
      _.forEach(this.summary, (i) => {
        total += _.sumBy(i.products, (x) => (x.isDiscount ? x.total : 0));
      });
      return total;
    },
    cartTotal() {
      let total = 0;
      _.forEach(this.summary, (i) => {
        _.forEach(i.products, (p) => {
          total += p.total;
        });
      });
      return total > 0 ? total : 0;
    },
    transactionFee() {
      const percent = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      if (preference.addToTotal >= 0) {
        fee = +((this.cartTotal * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        // Only use default total if no product or total setting
        fee = +((this.cartTotal * percent) / 100).toFixed();
      }
      return fee;
    },
    total() {
      return this.cartTotal + this.transactionFee;
    },
    payTodayTotal() {
      const { payToday } = this;
      let percent = 0;
      let defaultTransactionFee = this.$store.getters['cart/transactionFee'];
      if (!defaultTransactionFee) {
        const nationalMeta = this.$store.getters['national/getMeta'];
        if (nationalMeta && nationalMeta.transactionFee) {
          defaultTransactionFee = +nationalMeta.transactionFee;
        }
      }
      const preference = this.$store.getters['national/paymentPreference'];
      if (preference && preference.addToTotal >= 0) {
        percent = preference.addToTotal;
      } else {
        percent = defaultTransactionFee;
      }
      return +(payToday + ((payToday * percent) / 100)).toFixed();
    },
    requirePayment() {
      return this.cartTotal > 0;
    },
    fillingAddress() {
      const rego = _.head(this.payment.registrations);
      return _.get(rego, 'entity.contact.address.formatted', false) ? rego.entity.contact.address : false;
    },
    isPayDisabled() {
      return this.summary.length === 0;
    },
    paymentTitle() {
      return this.requirePayment ? 'Payment Details' : 'Complete your registration';
    },
    paymentButtonText() {
      return this.requirePayment ? 'Pay & Complete' : 'Complete';
    },
    payAfter() {
      return _.get(this, 'value.product.payAfter', false);
    },
    minPayment() {
      const minPayment = _.get(this, 'value.product.minPrice', 0);
      const { cartTotal } = this;
      return Math.min(minPayment, cartTotal);
    },
  },
  filters: {
    parsePrice(val) {
      const rs = (val / 100).toFixed(2);
      if (val < 0) return `-$${(Math.abs(rs)).toFixed(2)}`;
      return `$${rs}`;
    },
    parseProductType(val) {
      return (_.find(productTypes, (pt) => pt.type === val)).name;
    },
    cap(val) {
      return _.capitalize(val);
    },
    joinTag(vals) {
      return _.join(_.map(vals, (v) => v.name), ', ');
    }
  },
  watch: {
    cartTotal: {
      handler() {
        this.payToday = this.cartTotal;
      },
      immediate: true,
    }
  }
};
</script>

    <style scoped lang="scss">
    .payment-container {
      width: 100%;
      max-width: $lg;

      .event {
        color: #34647f;
      }
    }

    ::v-deep .item-table {
      border: 1px solid rgba(45, 58, 69, 0.1);

      th {
        background: #F6F8FA !important;
        padding-left: 1em;
        padding-right: 1em;
      }

      td {
        background-color: white !important;
        padding: 0.6em 1em;
      }

      .summary-product {
        width: auto;
        min-width: 10em;
      }

      .product-info {
        .name {
          color: #2D3A45;
          font-size: 1em;
        }

        .description {
          font-size: 0.8em;
          font-family: $fontLight;
        }
      }
    }

    .title {
      font-weight: bold;
      margin-right: 0.3em;
      // color: $primary;
    }

    .bottomBtn {
      max-width: 100%;
      width: 10em;
    }

    .payBtn {
      max-width: 100%;
      width: 15em;
    }

    .price-divider {
      padding: 0 0.5rem;
    }

    ::v-deep .custom-card {
      @media only screen and (max-width: $sm) {
        margin-left: -0.8em;
      }
      @media only screen and (max-width: $xs) {
        margin-left: -2em;
      }
    }
    .text-danger {
      color: red;
      font-size: 13px;
    }
    </style>
